import React from 'react'
import WrapperByRole, { WrapperByRoleProps } from '../components/Wrapper/WrapperByRole'

const AdminWrapper: React.FC<WrapperByRoleProps> = (props) =>
  <WrapperByRole role='administrator' {...props} />

export default AdminWrapper